import React from "react";
import { SvgIcon } from "@material-ui/core";


export default function BackIcon(): JSX.Element {
    return (
        <SvgIcon viewBox="0 0 21 32">
            <path
                d="M3.78354 0L0.309326 4L12.7172 16L0.309326 28.5L3.78354 32L20.6583 16L3.78354 0Z"
                fill="#ef793a"
            />
        </SvgIcon>
    );
}
